import { Box, ContentBlock } from 'braid-design-system';
import React from 'react';

import { StaticPageProvider } from '../../../../components';
import type { ActiveTab, ActiveSubTab } from '../../../../shared/types';

import CompanyProfilesEnquiryForm from './components/CompanyProfilesEnquiryForm/CompanyProfilesEnquiryForm';

const StaticPageProps = {
  title: 'Company Profiles Enquiry',
  returnUrl: '/products/company-profiles/enquire',
  eventName: 'company_profiles_enquiry__displayed',
  siteSection: 'products',
  activeTab: 'Products' as ActiveTab,
  activeSubTab: 'Company Profiles' as ActiveSubTab,
  currentPage: 'company profiles',
  shouldTrack: false,
};

export default () => (
  <StaticPageProvider {...StaticPageProps}>
    <Box background="surface" paddingY="xlarge" paddingX={['gutter', 'none']}>
      <ContentBlock>
        <CompanyProfilesEnquiryForm />
      </ContentBlock>
    </Box>
  </StaticPageProvider>
);
